import { useLanguage } from "./LanguageContext";
import impressumData from "../data/impressum.json";

export default function Impressum() {
  const { lang } = useLanguage();
  const defaultLang = impressumData.meta?.defaultLanguage || "de";
  const content = impressumData[lang] || impressumData[defaultLang];

  if (!content) return null;

  return (
    <section className="flex flex-col items-center px-4 py-8 max-w-4xl mx-auto text-white">
      <h1 className="text-3xl font-bold mb-8 text-center">{content.title}</h1>

      {content.blocks.map((block, i) => (
        <div key={i} className="w-full mb-6 text-center" style={{ whiteSpace: "pre-line" }}>
          <h2 className="text-xl font-semibold mb-2">{block.heading}</h2>
          <p className="leading-relaxed">
            {block.lines.map((line, j) => (
              <span key={j}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      ))}
    </section>
  );
}